import React from 'react'
import './header.css'
import CTA from './CTA'
import  HeaderSocials from './HeaderSocials'
import ME3 from '../../assests/me3.jpeg'

const Header = () => {
  return (
    <header>
      <div className="conatiner header__container">
        <h5>Hey I'm</h5>
        <h1>Prateek Arora</h1>
        <h5 className='text-light'>Front-End Developer</h5>
        <CTA />
        <HeaderSocials />
        <div className="myself">
        <img src={ME3} alt="Myself" />
        </div>
      </div>
    </header>
  )
}

export default Header